import react from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";

function AppointmentSuccess(){
    useEffect(() => {
             const scriptUrls = [
               'assets/js/jquery.min.js',
               'assets/js/bootstrap.bundle.min.js',
               'assets/js/moment.min.js',
               'assets/vendor/overlay-scroll/jquery.overlayScrollbars.min.js',
               'assets/vendor/overlay-scroll/custom-scrollbar.js',
               'assets/vendor/daterange/daterange.js',
               'assets/vendor/daterange/custom-daterange.js',
               'assets/vendor/jquery-ui/jquery-ui.min.js',
               'assets/vendor/jquery-ui/custom.js',
               'assets/vendor/datatables/dataTables.min.js',
               'assets/vendor/datatables/dataTables.bootstrap.min.js',
               'assets/vendor/datatables/custom/custom-datatables.js',
               'assets/js/custom.js'
             ];
         
             let isCancelled = false;
         
             // Load scripts sequentially
             const loadScriptsSequentially = async () => {
               for (const url of scriptUrls) {
                 if (isCancelled) break;
         
                 await new Promise((resolve, reject) => {
                   const script = document.createElement('script');
                   script.src = url;
                   script.onload = resolve;
                   script.onerror = reject;
                   document.body.appendChild(script);
                 });
               }
             };
         
             loadScriptsSequentially();
         
             return () => {
               isCancelled = true;
               // Optionally remove scripts if needed
             };
           }, []);
    return(
      <div>
       {/* App hero header starts */}
       <div className="app-hero-header d-flex align-items-center">
       {/* Breadcrumb starts */}
       <ol className="breadcrumb">
         <li className="breadcrumb-item">
           <a href="index-2.html">
             <i className="ri-home-3-line" />
           </a>
         </li>
         <li className="breadcrumb-item">Appointments</li>
         <li className="breadcrumb-item text-primary" aria-current="page">
           Appointment Confirm
         </li>
       </ol>
       {/* Breadcrumb ends */}
       {/* Sales stats starts */}
       <div className="ms-auto d-lg-flex d-none flex-row">
         <div className="input-group">
           <span className="input-group-text bg-primary-lighten">
             <i className="ri-calendar-2-line text-primary" />
           </span>
           <input type="text" id="abc" className="form-control custom-daterange" />
         </div>
       </div>
       {/* Sales stats ends */}
     </div>
     {/* App Hero header ends */}
     {/* App body starts */}
     <div className="app-body">
       {/* Row starts */}
       <div className="row gx-4">
         <div className="col-sm-12">
           <div className="card">
             <div className="card-body">
               {/* Row starts */}
               <div className="row gx-4 justify-content-center">
                 <div className="col-sm-4">
                   <div className="my-5 text-center">
                     <i className="text-primary display-1 ri-checkbox-circle-fill" />
                     <h4>Your Appointment Is Confirmed!</h4>
                     <p>Your appointment is confirmed with Dr. Margery Doyle on 28 Dec 2024 @3:00PM.</p>
                     <Link to="/edit-appointment" className="btn btn-outline-primary my-4" onClick={(e) => e.stopPropagation()}>EditAppointment</Link>
                     {/* <a href="edit-appointment.html" className="btn btn-outline-primary my-4">Edit Appointment</a> */}
                   </div>
                 </div>
               </div>
               {/* Row ends */}
             </div>
           </div>
         </div>
       </div>
       {/* Row ends */}
     </div>
     {/* App body ends */}
     </div>
    )
}
export default AppointmentSuccess;